<template>
  <div class="quiz">
    <quiz-result v-if="isFinish" :itemList="answerList" :resultList="quiz.result" @again="onAgain"></quiz-result>

    <template v-else>
      <quiz-item v-for="(item, index) in questionList" :key="`question-${index}`" :item="item" :active="active" :index="index" :total="questionListLength" :hasAnswer="hasIndex(answerList, index)" v-show="active === index" @select="onSelect" @next="onNext" @finish="onFinish"></quiz-item>
    </template>
  </div>
</template>

<script>
import QuizItem from './QuizItem'
import QuizResult from './QuizResult'

export default {
  components: {
    QuizItem,
    QuizResult
  },
  data () {
    return {
      quiz: [],
      active: 0,
      isFinish: false,
      answerList: []
    }
  },
  computed: {
    isMobile () {
      return this.$mq.resize && this.$mq.below(this.$mv.md)
    },
    questionList () {
      return this.quiz.questions
    },
    questionListLength () {
      return this.questionList.length
    }
  },
  mounted () {
    this.fetchData()
  },
  methods: {
    fetchData () {
      this.$http.static.get('/data/quiz.json')
        .then((response) => {
          this.quiz = response.data
        }, (error) => {
          console.error(error)
        }).catch(() => null)
    },
    hasIndex (array, index) {
      const isArray = Array.isArray(array)
      const isNotExist = typeof array[index] === 'undefined'

      return isArray && !isNotExist
    },
    onSelect (payload) {
      this.$set(this.answerList, payload.index, payload.value)
    },
    onNext () {
      this.active++
    },
    onFinish () {
      this.isFinish = true
    },
    onAgain () {
      this.answerList = []
      this.isFinish = false
      this.active = 0
    }
  }
}
</script>
